var _circle, _circle2, _circle3, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPathsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "paths-icon_svg__paths-icon",
    cx: 15,
    cy: 3,
    r: 2.5,
    stroke: "#fff",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "paths-icon_svg__paths-icon",
    cx: 15,
    cy: 13,
    r: 2.5,
    stroke: "#fff",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "paths-icon_svg__paths-icon",
    cx: 3,
    cy: 8,
    r: 2.5,
    stroke: "#fff",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "paths-icon_svg__paths-icon",
    d: "M5.5 8H9M9 3h4M9 13h4M9 13.5v-11",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
}

export default __webpack_public_path__ + "./fonts/paths-icon.ad0cf74073ab59645d9dc177cd8227a6.svg";
export { SvgPathsIcon as ReactComponent };